import { Loader2 } from "lucide-react";

type SpinnerSize = "sm" | "md" | "lg" | "xl";

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

const sizeStyles: Record<SpinnerSize, string> = {
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
  xl: "w-12 h-12",
};

export function Spinner({ size = "md", className = "", label }: SpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <Loader2
        className={`animate-spin text-[var(--color-text-secondary)] ${sizeStyles[size]} ${className}`}
        aria-label={label || "로딩 중..."}
      />
      {label && <p className="text-sm text-[var(--color-text-muted)]">{label}</p>}
    </div>
  );
}

export type { SpinnerProps };
